import { QualityRepository } from '../../domain/repositories/quality.repository';

export class DeleteQualityUseCase {
  constructor(private readonly qualityRepository: QualityRepository) {}

  async execute(id: string): Promise<void> {
    return this.qualityRepository.deleteQuality(id);
  }
}
